import moment from 'moment'
import { FlagColors, FLAG_TYPE_LABELS } from '../../interfaces/bbc'
import { FilterFieldType, IFilter } from './types'

export const FLAGS_SORT_OPTIONS = [
  {
    value: 'record_date DESC',
    label: 'Most Recent',
  },
  {
    value: 'record_date ASC',
    label: 'Oldest',
  },
  {
    value: 'resolved DESC',
    label: 'Resolved (Top)',
  },
  {
    value: 'resolved ASC',
    label: 'Resolved (Bottom)',
  },
]

export const FLAGS_LIST_FILTERS_CONFIG = [
  {
    field: 'flag',
    dbField: 'flag',
    type: FilterFieldType.Text,
    isSortable: true,
    placeholder: 'Flag',
    title: 'Flag',
  },
  {
    field: 'clientName',
    dbField: 'client_name',
    type: FilterFieldType.Autocomplete,
    title: 'Client',
    alias: 'flags',
  },
  {
    field: 'name',
    dbField: 'name',
    type: FilterFieldType.Autocomplete,
    title: 'Entity',
    alias: 'entityInfo',
  },
  {
    field: 'recordDate',
    dbField: 'record_date',
    type: FilterFieldType.Date,
    isSortable: true,
    title: 'Date Range',
    alias: 'flags',
  },
  {
    field: 'flagType',
    dbField: 'flag_type',
    type: FilterFieldType.List,
    isSortable: true,
    options: Object.keys(FLAG_TYPE_LABELS).map((key) => ({
      value: key,
      label: FLAG_TYPE_LABELS[key as keyof typeof FLAG_TYPE_LABELS],
    })),
    title: 'Type',
    isMultiple: true,
  },
  {
    field: 'resolved',
    dbField: 'resolved',
    type: FilterFieldType.Boolean,
    options: [
      {
        value: 'false',
        label: 'Open',
      },
      {
        value: 'true',
        label: 'Resolved',
      },
    ],
    isSortable: true,
    title: 'Status',
    alias: 'flags',
  },
  {
    field: 'flagName',
    dbField: 'flag_name',
    type: FilterFieldType.Autocomplete,
    title: 'Flag Name',
    alias: 'flags',
  },
  {
    field: 'flagColor',
    dbField: 'flag_color',
    type: FilterFieldType.List,
    isMultiple: true,
    isSortable: true,
    options: [
      {
        value: FlagColors.Red,
        label: 'Red',
      },
      {
        value: FlagColors.Yellow,
        label: 'Yellow',
      },
    ],
    title: 'Color',
  },
  {
    field: 'hasReplies',
    dbField: 'has_replies',
    type: FilterFieldType.List,
    options: [
      {
        value: 'true',
        label: 'Yes',
      },
      {
        value: 'false',
        label: 'No',
      },
    ],
    isSortable: true,
    title: 'Replies',
    alias: 'flags',
  },
  {
    type: FilterFieldType.QuickFilter,
    field: 'quickFilter',
    fields: [
      {
        field: 'userId',
        type: FilterFieldType.Text,
      },
    ],
    quickFilters: [
      {
        title: 'My Clients',
        isHidden: true,
        filters: {
          userId: '',
        },
      },
      {
        title: 'Red Flags',
        filters: {
          flagColor: [FlagColors.Red],
          resolved: [false],
        },
      },
      {
        title: 'New Flags',
        filters: {
          recordDateFrom: moment().subtract(14, 'days').format('YYYY-MM-DD'),
        },
      },
    ],
  },
] as const satisfies IFilter[]
